import { PureLightTheme } from '../../../styles/theme'
import { COLORS } from '../../../styles/variables'

export const aboutPageSx = {
  maxWidth: 760,
  margin: '0 auto',
  paddingBottom: '48px',
  [PureLightTheme.breakpoints.down('lg')]: {
    padding: '0 30px 72px 30px',
  },
}

export const aboutTitleSx = {
  margin: '0 0 16px 0',
  textAlign: 'center',
}

export const aboutSectionSx = {
  marginTop: 4,
}

export const aboutSectionTitleSx = {
  marginBottom: 1.5,
}

export const aboutParagraphSx = {
  color: COLORS.CHARCOAL_GREY,
  marginBottom: 1.5,
  '&:last-child': {
    marginBottom: 0,
  },
}

export const aboutCapabilityListSx = {
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
}

export const aboutCapabilityItemSx = {
  margin: 0,
}

export const aboutCapabilityTitleSx = {
  fontWeight: 600,
  marginBottom: 0.5,
}

export const aboutStepsSx = {
  margin: 0,
  paddingLeft: 2.5,
  color: COLORS.CHARCOAL_GREY,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
}
